import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { NewExclusionListDataProviderFactory } from '../factory/NewExclusionListDataProviderFactory';
import { NewExclusionListBaseDataProvider } from '../dataProvider/NewExclusionListBaseDataProvider';
import { NewExclusionListWebComponentSchema } from '../types';

export class NewExclusionListRepository extends BaseWebComponentRepository {
  public dataProviderFactory: NewExclusionListDataProviderFactory;
  public dataProvider: NewExclusionListBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new NewExclusionListDataProviderFactory(),
    });
  }

  async getDataForView(companyId, listId): Promise<NewExclusionListWebComponentSchema | undefined> {
    return (listId && companyId) ? this.getListInfo(companyId, listId) : undefined;
  }

  public async createExclusionItem(records): Promise<any> {
    let response;
    try {
      response = await this.dataProvider.createExclusionItem(records);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

  public async createExclusionList(records): Promise<any> {
    return await this.dataProvider.createExclusionList(records);
  }

  public async updateExclusionList(records): Promise<any> {
    return await this.dataProvider.updateExclusionList(records);
  }

  public async assignMultipleItemsToList(companyId, itemsIds, listId): Promise<any> {
    return await this.dataProvider.assignMultipleItemsToList(companyId, itemsIds, listId);
  }

  public async importCsv(fields, file): Promise<any> {
    return this.dataProvider.importCsv(fields, file);
  }

  public async getListInfo(companyId, listId): Promise<any> {
    let response;
    try {
      response = await this.dataProvider.getListInfo(companyId, listId);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

}
